import { render, staticRenderFns } from "./DialogPageCreateChat.vue?vue&type=template&id=e0ef8c40"
import script from "./DialogPageCreateChat.vue?vue&type=script&lang=js"
export * from "./DialogPageCreateChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports